import React from "react";
import clsx from "clsx";
import "./text-message.styles.scss";
import zCBLAnimationModule from "../../../core/engines";
import { SelectableItem } from "../../SelectableItem";
import { SnapEffectContainer } from "../../../core/animations";

import type { IUITextMessageContent } from "../../../shared/types";
import { $Logger } from "../../../../logger";

export interface TextMessageProps {
	className?: string;
	content: IUITextMessageContent;
}

const BlockName = "text-message";
const ClassNames = {
	Block: BlockName,
	Modifiers: {
		Selected: "--selected",
	},
	Elements: {},
} as const;

export type TextMessageComponent = React.FC<TextMessageProps> & {
	ClassNames: typeof ClassNames;
};

export const TextMessage = ((props: TextMessageProps) => {
	const { content: message } = props;

	return (
		<SelectableItem selectKey={`${message.cliMsgId}`}>
			{({ attrs, isSelected }) => {
				return (
					// <zCBLAnimationModule.Component.Flipped
					// 	flipId={message.cliMsgId}
					// 	// shouldFlip={() => false}
					// 	// inverseFlipId={`msg-lo-${props.content.cliMsgId}`}
					// 	//Todo: Sử dụng inverseFlipId để xử lý animation khi xoá message.
					// 	//Todo2: Sử dụng shouldFlip hoặc shouldInvert hoặc sử dụng flipIds để quyết định....
					// 	onExit={(element, index, removeElement, decisionData, animationNG) => {
					// 		$Logger.log("dongmt onExit TextMessage: ", message.cliMsgId);
					// 		SnapEffectContainer.EventListener.dispatchEvent(
					// 			"animate-snap",
					// 			element,
					// 		);
					// 		// removeElement();
					// 	}}
					// >
					<div
						className={clsx(
							TextMessage.ClassNames.Block,
							props.className,
							isSelected && TextMessage.ClassNames.Modifiers.Selected,
						)}
						{...attrs}
					>
						{message.content}
					</div>
					// </zCBLAnimationModule.Component.Flipped>
				);
			}}
		</SelectableItem>
	);
}) as TextMessageComponent;
TextMessage.ClassNames = ClassNames;
